module.exports = __webpack_public_path__ + "static/media/fanyuvo-event2.53ff771e.jpg";